import type { CSSProperties } from "react";
import { normalizeTextHtml } from "../domain/sanitize";
import {
  resolveLinkColor,
  type TextTheme,
} from "../domain/text-theme";
import type { TextBlock } from "../domain/types";
import { emailBuilderLinkColorCssVar } from "../editing/emailBuilderCanvasBlockProjection";
import { isEmailBuilderRichTextEmpty } from "../editing/richText/emailBuilderRichTextHtml";

export function resolveInlineTextContent(block: TextBlock): string {
  return normalizeTextHtml(block.html);
}

export function isInlineTextEmpty(block: TextBlock): boolean {
  return isEmailBuilderRichTextEmpty(resolveInlineTextContent(block));
}

export function resolveInlineTextEditorStyle(
  block: TextBlock,
  textTheme: TextTheme,
): CSSProperties {
  return emailBuilderLinkColorCssVar(resolveLinkColor(block, textTheme));
}
